import numeral from 'numeral';
import moment from 'moment';

class Formats {
  static currency(value: number, decimals: number = 0) {
    /**
     * This check needs to be done because otherwise the formatter between these values
     * removes the numeral value and leaves only the currency sign.
     * Example: -0.15 equals -$
     */
    if (-0.5 <= value && value < 0.5 && decimals === 0) {
      return `$${numeral(0).format('0,0')}`;
    }
    return numeral(value).format(`$0,0.${Array(decimals + 1).join('0')}`);
  }

  static date(value: string, format: string = 'L') {
    return moment(value).format(format);
  }

  static number(value: number, decimals: number = 0, sign: boolean = false) {
    return numeral(value).format(`${sign ? '+' : ''}0,0.${Array(decimals + 1).join('0')}`);
  }

  static percentage(value: number, sign: boolean = true): string {
    return numeral(value / 100).format(`${value > 0 && sign ? '+' : ''}0,0.0%`);
  }
}

export default Formats;
